import { parseNumber } from '@/plugins/utils'

class ProductionAvenant {
  constructor(data = {}) {
    const {
      id,
      collaborateurId,
      ficheId,
      produitId,
      motifChuteId,
      dateChute,
      dateEffet,
      dateSaisie,
      numero,
      nom,
      prenom,
      dateNaissance,
      sel,
      gedIds,
      gedBloquantIds,
      fdcId,
      typeId,
      controle,
      commentaires,
      calculs,
      bloquant,
      created,
      garantieDeces,
      collectifDetails,
      due,
      dsn,
      duedsn,
    } = data

    this.id = id

    this.collaborateurId = collaborateurId
    this.ficheId = ficheId || ''
    this.produitId = produitId
    this.motifChuteId = motifChuteId
    this.fdcId = fdcId
    this.typeId = typeId

    this.gedIds = gedIds || []
    this.gedBloquantIds = gedBloquantIds || []

    this.dateChute = dateChute || ''
    this.dateEffet = dateEffet || ''
    this.dateSaisie = dateSaisie || ''
    this.numero = numero || ''
    this.nom = nom || ''
    this.prenom = prenom || ''
    this.dateNaissance = dateNaissance || ''
    this.sel = sel ? '1' : '0'
    this.controle = !!controle
    this.commentaires = commentaires || ''
    this.calculs = calculs || {}
    this.bloquant = bloquant || {}
    this.created = created || ''
    this.garantieDeces = garantieDeces ? 1 : 0
    this.collectifDetails = collectifDetails || {}
    this.due = !!due
    this.dsn = !!dsn
    this.duedsn = duedsn || {}
  }

  isNew() {
    return !this.id
  }

  isBloque() {
    const total =
      typeof this.bloquant.total !== 'undefined' ? this.bloquant.total : 0
    return total !== 0
  }

  isChute() {
    return !!this.dateChute && !this.produitId
  }

  hasChute() {
    return !!this.dateChute && !!this.produitId
  }
}

export default ProductionAvenant
